import { motion } from 'framer-motion';
import workspacePeek from '@/assets/workspace-peek.png';

const DESCRIPTOR_CHIPS = [
  'Documents & transcripts',
  'Coding workspace',
  'Theme development',
  'Evidence-linked outputs',
] as const;

export function WorkspacePeekSection() {
  return (
    <section className="pt-4 sm:pt-6 md:pt-8 pb-6 sm:pb-8 md:pb-10" aria-label="Inside Verithos workspace">
      <div className="max-w-6xl 2xl:max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        {/* Eyebrow */}
        <p className="text-[10px] sm:text-[11px] font-semibold uppercase tracking-[0.18em] text-evidence text-center mb-5 sm:mb-6">
          Inside Verithos
        </p>

        {/* Screenshot with top fade */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-40px' }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          className="relative rounded-lg overflow-hidden"
        >
          {/* Top edge fade — white to transparent */}
          <div
            className="absolute inset-x-0 top-0 z-10 pointer-events-none"
            style={{
              height: '7%',
              background: 'linear-gradient(to bottom, hsl(var(--background)), transparent)',
            }}
          />

          <img
            src={workspacePeek}
            alt="Verithos qualitative analysis workspace showing transcript coding, suggested codes, and theme development panel"
            width={1904}
            height={918}
            className="w-full h-auto block"
            style={{ imageRendering: 'auto', WebkitFontSmoothing: 'antialiased' }}
            loading="eager"
            fetchPriority="high"
            decoding="async"
            draggable={false}
          />
        </motion.div>

        {/* Descriptor chips */}
        <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3 mt-5 sm:mt-6">
          {DESCRIPTOR_CHIPS.map((label) => (
            <span
              key={label}
              className="px-3 py-1 sm:px-3.5 sm:py-1.5 rounded-full text-[10px] sm:text-[11px] font-medium text-muted-foreground bg-muted/40 border border-border/30 select-none"
            >
              {label}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
